import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '../shared/base-components/base.component';
import { AccessControlType } from '../foundation/models/enums/access-control-type.enum';
import { NoteViewModel } from './models/views/note-view.model';

@Component({
    selector: 'note-entry',
    templateUrl: './entry.html'
})
export class NoteEntryComponent extends BaseComponent {
    @Input()
    public note: any = {};
    @Output()
    public noteSaved: EventEmitter<any>;
    @Output()
    public noteCancelled: EventEmitter<boolean>;
    public showButtonLoading = false;
    public isOIGFraudNoteClaim = false;
    public errors: any = {};
    public noteEntryForm: UntypedFormGroup;
    public showErrorTable = false;
    private accessControlType: AccessControlType = new AccessControlType();

    constructor(
        private fb: UntypedFormBuilder
    ) {
        super();
        this.noteSaved = new EventEmitter<any>();
        this.noteCancelled = new EventEmitter<boolean>();
    }

    public ngOnInit(): void {
        this.UseHelpContent('#CONTENT/Cross_Functional/Notes.htm%3FTocPath%3DCross_Functional|_____15');
        this.showButtonLoading = false;
        this.isOIGFraudNoteClaim = this.auth.hasACSTransactionClaimEx(this.auth.acsTransactionClaim, this.accessControlType.CanManageOIGVehNote.value) == true;
        this.createForm(this.fb);
    }

    public cancelNoteEntry = (): void => {
        this.noteCancelled.emit(true);
    };

    public saveNote = (): void => {
        this.showErrorTable = false;

        if (this.noteEntryForm.valid) {
            this.showButtonLoading = true;
            let model = this.getModel();
            this.noteSaved.emit(model);
            this.showButtonLoading = false;
        }
    };

    private createForm = (formBuilder: UntypedFormBuilder): void => {
        this.noteEntryForm = formBuilder.group({
            noteDescription: [this.note.noteDescription, Validators.compose([Validators.required, Validators.maxLength(1000)])],
            isConfidential: [this.note.isConfidential],
            isOIGFraud: [this.note.isOIGFraud]
        });
    };

    private getModel = (): NoteViewModel => {
        let model = new NoteViewModel();
        Object.assign(model, this.note);
        model.isConfidential = true == this.noteEntryForm.get('isConfidential').value;
        model.isOIGFraud = true == this.noteEntryForm.get('isOIGFraud').value;
        model.noteDescription = this.noteEntryForm.get('noteDescription').value;

        return model;
    };
}
